export default "__VITE_ASSET__BMrMFf$J__"